<template>
  <aside
    class="hidden shrink-0 flex-col gap-4 border-obsidian-200 bg-white pl-6 lg:sticky lg:top-0 lg:flex lg:w-72 lg:self-start lg:border-l"
  >
    <template v-if="media">
      <MediaPickerPreview :media="media" />

      <div class="space-y-3">
        <h3 class="text-lg font-semibold">{{ media.title }}</h3>
        <MediaEncodingStatusBadge :status="media.encodingStatus" size="md" />

        <dl class="space-y-2 text-sm text-obsidian-700">
          <div v-if="media.width && media.height" class="flex justify-between gap-4">
            <dt class="text-obsidian-500">{{ t('dimensions') }}</dt>
            <dd>{{ media.width }} × {{ media.height }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-obsidian-500">{{ t('created') }}</dt>
            <dd>{{ formatDate(media.createdDate, getDateFormat()) }}</dd>
          </div>
        </dl>
      </div>
    </template>
    <p v-else class="text-sm text-obsidian-500">{{ t('selectItemHint') }}</p>

    <div class="flex flex-col gap-2 border-t border-obsidian-100 pt-4">
      <CVButton variant="default" :disabled="!media" @click="emit('confirm')">
        {{ t('select') }}
      </CVButton>
      <CVButton variant="secondary" @click="emit('cancel')">
        {{ t('cancel') }}
      </CVButton>
    </div>
  </aside>
</template>

<script lang="ts" setup>
import type { Media as RosMedia } from '@carvia/ros-client-types';
import CVButton from '@/components/buttons/CVButton.vue';
import MediaEncodingStatusBadge from '@/components/badges/MediaEncodingStatusBadge.vue';
import MediaPickerPreview from './MediaPickerPreview.vue';
import { formatDate } from '@/hooks/use-formatted-date';
import { getDateFormat } from '@/hooks/use-date-format';
import { useI18n } from 'vue-i18n';

defineProps<{
  media: RosMedia | null;
}>();

const emit = defineEmits<{
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "dimensions": "Dimensions",
    "created": "Created",
    "selectItemHint": "Select a media item to see details.",
    "cancel": "Cancel",
    "select": "Select"
  },
  "de": {
    "dimensions": "Abmessungen",
    "created": "Erstellt",
    "selectItemHint": "Wähle ein Medium aus, um Details zu sehen.",
    "cancel": "Abbrechen",
    "select": "Auswählen"
  },
  "es": {
    "dimensions": "Dimensiones",
    "created": "Creado",
    "selectItemHint": "Selecciona un medio para ver los detalles.",
    "cancel": "Cancelar",
    "select": "Seleccionar"
  }
}
</i18n>
